// @flow
import React from 'react';

import { getMetaBySlug } from 'utils/seoUtils';

import { withHelmet } from 'infrastructure/seo/Helmet';
import SubMenuHeaderContainer from 'containers/header/SubMenuHeaderContainer';
import Breadcrumb from 'components/fragments/Breadcrumb';
import BackgroundImage from 'containers/fragments/BackgroundImageContainer';
import LiveScore from 'containers/fragments/LiveScoreContainer';

export type StateProps = {
  title: string,
  slug_parent: string,
  slug: string,
  titleParent: string,
  description: string,
  featured_media: {
    src: string,
    legend: string,
  },
  templateDetail: string,
  meta_description: string,
  meta_title: string,
  banniere: string,
  clubName: string,
  acronyme: string,
  rencontresLive: number,
};

type Props = {
  title: string,
  withSubMenu: boolean,
  className?: string,
  parentSlug?: string,
  parentName?: string,
} & StateProps;

const PageNodeHeader = (props: Props) => {
  const {
    className,
    featured_media,
    titleParent,
    slug_parent,
    parentSlug,
    parentName,
    title,
    description,
    withSubMenu,
    slug,
    banniere,
    clubName,
    acronyme,
    rencontresLive
  } = props;

  let classTemplate = false;

  if (rencontresLive) {
    classTemplate = 'banner--live-score';
  }
  const parent = {
    name: parentName ? parentName : (titleParent ? titleParent : ''),
    to: `/${parentSlug ? parentSlug : (slug_parent ? slug_parent : '')}`,
  };

  const h1TitleLink = () => {
    let titleLink = '';
    if (slug_parent === 'jouer_encadrer') {
      if (slug === 'entrainements' 
        || slug === 'cout-de-la-pratique'
        || slug === 'modalites-d-inscription') {
          titleLink = ' - ';
        }
      else {
        titleLink = ' - ';
      }
    }
    return titleLink;
  };

  const h1TitleClub = () => {
    let titleClub = '';
    if (slug_parent === 'jouer_encadrer'
      && slug === 'cout-de-la-pratique'
      && acronyme !== '') {
        titleClub = `${acronyme}`;
      }
    else if (slug_parent === 'jouer_encadrer' 
      && slug !== 'cout-de-la-pratique') {
        titleClub = `${clubName}`;
      }
    return titleClub;
  };

  return (
    <section className={`banner ${className ? className: ''} ${classTemplate ? classTemplate: ''}`}>
      <BackgroundImage
        className="banner__thumbnail img-blue-dark"
        illustration={featured_media.src || banniere}
        baliseImg={false}
      />
      <div className="container">
        <Breadcrumb
          elements={[
            { name: 'accueil', to: '/' },
            parent,
            title ? title : ''
          ]}
          isDark
        />

        <h1 className="ft-h2">
          {title} {h1TitleLink()} {h1TitleClub()}
        </h1>
        <p className="banner__desc">{description}</p>
      </div>
      {withSubMenu && <SubMenuHeaderContainer subMenuPath={`/${slug_parent}/${slug}`} />}
      <LiveScore />
    </section>
  );
};

export default withHelmet(PageNodeHeader)((Helmet, pageProps) => {
  const {
    match: {
      params: {
        slug,
        slugNode,
      },
    },
    clubName,
    meta_description,
    meta_title,
  } = pageProps;
  const meta = getMetaBySlug(`${slug}/${slugNode}`);
  const ogimage = pageProps.featured_media.src;
  const ogimagetitle = pageProps.featured_media.title;
  return (
    <Helmet>
      <title>{meta_title}</title>
      <meta name={'description'} content={meta_description} />
      <meta name={'keywords'} content={meta.keywords(clubName)} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={meta_title} />
      <meta property={'og:description'} content={meta_description} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {ogimage && <meta property={'og:image:url'} content={ogimage} />}
      {(ogimage && ogimagetitle) && <meta property={'og:image:title'} content={ogimagetitle} />}
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
